export default {"src":"/_next/static/media/coop-illu.8b4d9a11.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};